import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['store']

  switch({ params: { name } }) {
    this.storeTargets.forEach(el => {
      if (el.dataset.name === name) {
        el.classList.add(el.dataset.klass)
      } else {
        el.classList.remove(el.dataset.klass)
      }
    })
  }
}
